import FiltersMenu from "components/app/project/filters-menu";
import PerformanceMeasurementComponent from "components/app/project/performance-measurement";
import moment from "moment";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "types";
import './performance-measurement.scss';

function PerformanceMeasurent (this: any){
    const state = useSelector((state: RootState) => state);
    const params: any = useParams();
    const [dateFrom, setDateFrom] = useState(moment().subtract(1, 'd').set('h', 0).set('m', 0).set('s', 0));
    const [dateTo, setDateTo] = useState(moment());
    const [streamIds, setStreamIds] = useState<number[]>([7, 8, 9]);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const filtersRef = useRef<any>();

    useEffect(() => {
        if (state.project) {
            if (state.project.ProjectTypeId === 5) {
                setStreamIds([7, 8, 9]);
            } else {
                if (state.project.ProjectSubTypeId === 7) {
                    setStreamIds([7]);
                } else if (state.project.ProjectSubTypeId === 8) {
                    setStreamIds([8]);
                } else if (state.project.ProjectSubTypeId === 9) {
                    setStreamIds([10]);
                } else if (state.project.ProjectSubTypeId === 10) {
                    setStreamIds([9]);
                } else if (state.project.ProjectSubTypeId === 11) {
                    setStreamIds([11]);
                }
            }
        }
    }, [state.project])
    
    return (
        <div className="performance-measurement">
            <div className='top-filter'>
                <p className="project-name">{state.project?.Description}</p>
                <p className="project-type">{state.project?.ProjectType}</p>
                <span onClick={() => setFiltersOpen(true)} ref={filtersRef}>Filter<i className={`fal ${filtersOpen ? 'fa-times' : 'fa-sliders-h'}`}></i></span>
                <FiltersMenu 
                            open={filtersOpen}
                            setOpen={setFiltersOpen}
                            dateFrom={dateFrom}
                            setDateFrom={setDateFrom}
                            dateTo={dateTo}
                            setDateTo={setDateTo}
                            streamIds={streamIds}
                            setStreamIds={setStreamIds}
                            projectTypeId={state.project?.ProjectTypeId}
                            showDatePicker={false}
                            buttonRef={filtersRef} 
                />
            </div>     
            <div className="components">
                <PerformanceMeasurementComponent projectId={params.projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds}/>
            </div>
        </div>
    )
}

export default PerformanceMeasurent